module.exports = __webpack_public_path__ + "static/media/16.216cbed0.jpg";